// Marketplaces Dashboard (Plan 9 FE) — brand list + entry points. Mobile-first:
// cards stack on small screens, grid from `sm`.
import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { Loader2, Package, ArrowRight } from "lucide-react";
import { mkt } from "@/lib/api/marketplaces";

export function Dashboard() {
  const brands = useQuery({ queryKey: ["mkt", "brands"], queryFn: () => mkt.listBrands() });

  return (
    <div className="px-4 py-5 md:px-8 max-w-5xl mx-auto space-y-5">
      <header>
        <h1 className="text-2xl font-bold text-text-primary tracking-tight">Brands</h1>
        <p className="text-text-muted text-sm">
          Pick a brand to audit and optimize its Amazon listings.
        </p>
      </header>

      {brands.isLoading && (
        <div className="flex items-center gap-2 text-text-muted text-sm">
          <Loader2 className="animate-spin" size={16} /> Loading brands…
        </div>
      )}
      {brands.isError && (
        <div className="text-sm text-red-600">Couldn't load brands right now.</div>
      )}

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
        {(brands.data ?? []).map((b) => (
          <Link
            key={b.slug}
            to={`/brand/${b.slug}/library`}
            className="group flex items-center gap-3 rounded-xl border border-border bg-bg-card p-4 hover:border-accent transition-colors"
          >
            <div className="size-10 rounded-lg bg-bg-subtle flex items-center justify-center text-text-secondary shrink-0">
              <Package size={18} />
            </div>
            <div className="min-w-0 flex-1">
              <div className="font-medium text-text-primary truncate">{b.name}</div>
              <div className="text-xs text-text-muted truncate">{b.slug}</div>
            </div>
            <ArrowRight
              size={16}
              className="text-text-dim group-hover:text-accent transition-colors shrink-0"
            />
          </Link>
        ))}
      </div>

      {brands.data && brands.data.length === 0 && (
        <div className="rounded-xl border border-border bg-bg-card p-8 text-center text-text-muted text-sm">
          No brands yet. Onboard one to get started.
        </div>
      )}
    </div>
  );
}

export default Dashboard;
